import BackgroundColorPicker from './background-color-picker';

export default BackgroundColorPicker;
